import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-pillbox-divider',
  templateUrl: './pillbox-divider.component.html',
  styleUrls: ['./pillbox-divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PillboxDividerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
